module.exports = __webpack_public_path__ + "static/media/wave-front.78ba9ddc.svg";